import { render } from "./board.vue?vue&type=template&id=1796d806"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"

import "./board.vue?vue&type=style&index=0&id=1796d806&rel=stylesheet%2Fscss&lang=scss"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/board.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1796d806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1796d806', __exports__)) {
    api.reload('1796d806', __exports__)
  }
  
  module.hot.accept("./board.vue?vue&type=template&id=1796d806", () => {
    api.rerender('1796d806', render)
  })

}


export default __exports__